import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { getUserInfo as _getUserInfo, orderNum, pageVisit as _pageVisit, getUnableNum as _getUnableNum } from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import { readCookie } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.infoList = {}; // 价格列表
    _this.ordernumber = {};
    _this.menus = [{
      name: '个人账户',
      isOpen: true,
      child: [{
        id: 1,
        name: '个人中心'
      }, {
        id: 2,
        name: '个人信息'
      }, {
        id: 3,
        name: '安全设置'
      }, {
        id: 4,
        name: '地址管理'
      }]
    }, {
      name: '交易管理',
      isOpen: true,
      child: [{
        id: 5,
        name: '我的订单'
      }, {
        id: 6,
        name: '售后服务'
      }]
    }, {
      name: '客户服务',
      isOpen: true,
      child: [{
        id: 7,
        name: '发票资质'
      }]
    }];
    _this.currentIndex = 1;
    _this.unableNum = 0;
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getUserInfo();
      this.pageVisit();
      this.getUnableNum();
    }
  }, {
    key: "getUnableNum",
    value: function () {
      var _getUnableNum2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _getUnableNum({
                companyId: 1
              });
            case 2:
              res = _context.sent;
              if (res.data.code === 100) {
                this.unableNum = res.data.data;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getUnableNum() {
        return _getUnableNum2.apply(this, arguments);
      }
      return getUnableNum;
    }()
  }, {
    key: "goOrder",
    value: function goOrder(id) {
      this.$router.push(id !== 4 ? "/order-list?id=".concat(id, "&from=user") : '/order-list?from=user');
    }
  }, {
    key: "goExchange",
    value: function goExchange() {
      this.$router.push('exchange-list');
    }
  }, {
    key: "changeChild",
    value: function () {
      var _changeChild = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(index) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.currentIndex = index;
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function changeChild(_x) {
        return _changeChild.apply(this, arguments);
      }
      return changeChild;
    }()
  }, {
    key: "getUserInfo",
    value: function () {
      var _getUserInfo2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var anchor, res, ordernumber;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              anchor = readCookie('anchor');
              _context3.next = 3;
              return _getUserInfo({
                companyId: 1
              });
            case 3:
              res = _context3.sent;
              this.infoList = res.data.data;
              _context3.next = 7;
              return orderNum({
                src: anchor ? anchor.src ? anchor.src : 2 : 4,
                equip: anchor ? anchor.equip : 4,
                version: anchor ? anchor.version : '',
                companyId: 1
              });
            case 7:
              ordernumber = _context3.sent;
              this.ordernumber = ordernumber.data.data;
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getUserInfo() {
        return _getUserInfo2.apply(this, arguments);
      }
      return getUserInfo;
    }() // 访问页面数据埋点
  }, {
    key: "pageVisit",
    value: function pageVisit() {
      var anchor = readCookie('anchor');
      _pageVisit({
        pageType: 4,
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        src: anchor ? anchor.src ? anchor.src : 2 : 4,
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        companyId: 1
      });
    }
  }]);
}(Vue);
__decorate([Action('card/setCardNum')], default_1.prototype, "setCardNum", void 0);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    NavMenu: NavMenu
  }
})], default_1);
export default default_1;